import uuid from 'uuid/v4';
import MessageBroker from '@Services/MessageBroker';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import Auth from '@Services/Auth';
import { goToAdvancedSearch, goToLanding } from '@Pages/Hopinto/actions';
import HttpRequest from '@Services/RequestFactory';
import { MAP_CONTEXTS } from '@Pages/Hopinto/constants';

/**
 * @ngdoc method
 * @methodOf app.hopinto:HopintoQueryFactory
 * @name resolveHopintoQuery
 * @param {Object} params
 * @param {Object} location
 * @description processes hopinto that uses advanced query
 */
// eslint-disable-next-line import/prefer-default-export
export const resolveHopintoQuery = (params, location) => {
  // TODO remove replacing new path
  const url = HttpRequest.getUrlWithPrefix(location.pathname + location.search);
  const { alert, result, database, ui: uiDirectives } = params;

  // RXFE-5717 we don't need extra request to BE, and just show alerts page, scrolling to the matched one
  if (alert && !result) {
    history.push({
      pathname: paths.ALERTS,
      state: { alert, database },
    });
    return false;
  }

  return (async () => {
    try {
      const data = await MessageBroker.send({ url, method: 'GET' });
      // hopInto query was resolved by the server
      // convert hitsPerPage into {number} if specified in hopInto params, otherwise - {null}
      const hitsPerPage = params.hitsPerPage ? Number(params.hitsPerPage) : null;
      const request = {
        queryFactItem: data,
        searchId: uuid(),
        hitsPerPage,
        context: params.context ? MAP_CONTEXTS[params.context] : 'reactions',
      };

      goToAdvancedSearch({
        importedQuery: request,
        autoSearch: 'hopInto',
        hitsPerPage,
        uiDirectives,
        database,
      });
    } catch (e) {
      Logger.debug(e);
      // server could not resolve the query, fallback to quick search page
      // auth interceptor will notify the error
      if (Auth.getAccessToken()) {
        goToLanding();
      }
    }
  })();
};
